import root from './manifests/vibe.proto';
import rootPhraseSpotting from './manifests/phrase_spotting.proto';

const { SpotterKind } = rootPhraseSpotting.phrase_spotting;

const proto = {
    MechanismName: root.vibe.AuthenticationRequest.MechanismName,
    RecognizeRequest: root.vibe.RecognizeRequest,
    RecognizeResponse: root.vibe.RecognizeResponse,
    ServiceMessage: root.vibe.ServiceMessage,
    ServiceMessageStatus: root.vibe.ServiceMessage.Status,
    AudioEncoding: root.vibe.AudioEncoding,
    OperationMode: root.vibe.RecognitionConfig.OperationMode,
    Channel: root.vibe.AudioChunkWithMetadata.Channel,
    AudioChunkWithMetadata: root.vibe.AudioChunkWithMetadata,
    ChannelControl: root.vibe.ChannelControl,
    Vendor: root.vibe.SpeechRecognitionResult.Vendor,
    Source: root.vibe.SessionInfo.Source,
    FinalizationReason: root.vibe.FinalizationToken.Reason,
    IntegrationMethod: root.vibe.CallDetectionConfig.IntegrationMethod,
    ExplicitIntegrationSource: root.vibe.CallDetectionConfig.ExplicitIntegrationSource
};

const spottingKindToProto = (kind: unknown = '') => {
    if (typeof kind === 'number' && Number.isFinite(kind) && SpotterKind[kind] !== undefined) {
        return kind;
    }

    const normalizedKind = String(kind || '').toUpperCase();
    return SpotterKind[normalizedKind] || SpotterKind.UNKNOWN;
};

const spottingConfigToProto = (cfg: unknown = {}) => {
    const source = (cfg && typeof cfg === 'object' ? cfg : {}) as Record<string, unknown[]>;
    const mapper = (acc: Record<string, unknown>, entry: string) => {
        acc[entry] = (source[entry] || []).map(phrase => {
            const item = phrase as Record<string, unknown>;
            return {
                ...item,
                kind: spottingKindToProto(item.kind)
            };
        });
        return acc;
    };

    return Object.keys(source).reduce(mapper, {} as Record<string, unknown>);
};

export { proto, spottingConfigToProto };
